const e = {
  "pipeline-changes-track-mobile-item__trigger": "pipeline-changes-track-mobile-item__trigger",
  "pipeline-changes-track-mobile-item__visually-hidden": "pipeline-changes-track-mobile-item__visually-hidden",
  "pipeline-changes-track-mobile-item__name": "pipeline-changes-track-mobile-item__name",
  "pipeline-changes-track-mobile-item__indication": "pipeline-changes-track-mobile-item__indication",
  "pipeline-changes-track-mobile-item__toggle-icon": "pipeline-changes-track-mobile-item__toggle-icon",
  "pipeline-changes-track-mobile-item__toggle-icon--open": "pipeline-changes-track-mobile-item__toggle-icon--open",
  "pipeline-changes-track-mobile-item__panel": "pipeline-changes-track-mobile-item__panel",
  "pipeline-changes-track-mobile-item__panel--open": "pipeline-changes-track-mobile-item__panel--open",
  "pipeline-changes-track-mobile-item__panel-content": "pipeline-changes-track-mobile-item__panel-content"
};
export {
  e as default
};
